import { apiGet, apiPost, apiPatch, apiDelete } from './client';

export interface SaveCustomerData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  eventId: string;
  eventTitle: string;
  paymentMethod: string;
  status: 'INFO_FILLED' | 'ORDER_PLACED' | 'PAYMENT_COMPLETED';
  orderData?: any;
  billingAddress?: string;
  city?: string;
  country?: string;
  zipCode?: string;
  deliveryAddress?: string;
  deliveryCity?: string;
  deliveryNotes?: string;
}

export interface CustomersQuery {
  status?: string;
  eventId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const customersApi = {
  // Get all customer data (admin only)
  getAllCustomers: (query?: CustomersQuery): Promise<any> => {
    return apiGet('/customers', { params: query });
  },

  // Get customer statistics
  getCustomerStats: (eventId?: string): Promise<any> => {
    return apiGet('/customers/stats', { params: { eventId } });
  },

  // Save customer checkout data
  saveCustomerData: (data: SaveCustomerData): Promise<any> => {
    return apiPost('/customers', data);
  },

  // Update customer status (admin only)
  updateCustomerStatus: (
    id: string,
    status: string,
    orderData?: any
  ): Promise<any> => {
    return apiPatch(`/customers/${id}/status`, { status, orderData });
  },

  // Delete customer data (admin only)
  deleteCustomerData: (id: string): Promise<any> => {
    return apiDelete(`/customers/${id}`);
  },

  // Export customer data (admin only)
  exportCustomerData: (query?: CustomersQuery): Promise<any> => {
    return apiGet('/customers/export', { params: query });
  },
};




